import React from "react";
import { getApiBaseUrl } from "../../../utils/api";
import LoadingSpinner from "../components/LoadingSpinner";

const API_BASE_URL = getApiBaseUrl();

const CertificatesTab = ({ 
  certificates, 
  loading, 
  formatDate,
  certificatesPagination,
  certificateSearchTerm,
  setCertificateSearchTerm,
  onFetchCertificates
}) => {
  return (
    <div>
      <div className="flex justify-between items-center mb-8">
        <div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Certificados Emitidos</h2>
          <p className="text-gray-600">Visualize todos os certificados emitidos</p>
        </div>
      </div>

      {/* Search */}
      <div className="mb-6 bg-white rounded-xl shadow-sm border border-gray-100 p-6">
        <div className="flex items-center space-x-4">
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Pesquisar por usuário
            </label>
            <input
              type="text"
              value={certificateSearchTerm}
              onChange={(e) => setCertificateSearchTerm(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  onFetchCertificates(1, certificateSearchTerm);
                }
              }}
              placeholder="Digite o nome ou email do usuário..."
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
          <div className="flex space-x-2">
            <button
              onClick={() => onFetchCertificates(1, certificateSearchTerm)}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-colors duration-200"
            >
              Pesquisar
            </button>
            <button
              onClick={() => {
                setCertificateSearchTerm("");
                onFetchCertificates(1, "");
              }}
              className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg font-medium transition-colors duration-200"
            >
              Limpar
            </button>
          </div>
        </div>
      </div>

      {loading ? (
        <LoadingSpinner message="Carregando certificados..." />
      ) : (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Usuário
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Curso
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Pontuação
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Data de Emissão
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Certificado
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {certificates.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="px-6 py-12 text-center text-gray-500">
                      <div className="flex flex-col items-center">
                        <svg
                          className="w-12 h-12 text-gray-400 mb-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                          />
                        </svg>
                        <p className="text-lg font-medium text-gray-900 mb-2">
                          Nenhum certificado emitido
                        </p>
                        <p className="text-gray-500">
                          Certificados aparecerão aqui quando usuários completarem cursos
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  certificates.map((cert) => (
                    <tr key={cert.certificate_id}>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center">
                            <span className="text-white text-sm font-semibold">
                              {cert.user_name.charAt(0).toUpperCase()}
                            </span>
                          </div>
                          <div className="ml-4">
                            <div className="text-sm font-medium text-gray-900">
                              {cert.user_name}
                            </div>
                            <div className="text-sm text-gray-500">{cert.user_email}</div>
                            <div className="text-sm text-gray-500">{cert.user_company}</div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {cert.course_title}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span
                          className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                            cert.score >= 90
                              ? "bg-green-100 text-green-800"
                              : cert.score >= 80
                              ? "bg-yellow-100 text-yellow-800"
                              : "bg-red-100 text-red-800"
                          }`}
                        >
                          {cert.score.toFixed(1)}%
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {formatDate(cert.generated_at)}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-blue-600">
                        <button
                          onClick={async () => {
                            const { downloadCertificate } = await import('../../../utils/certificateDownload');
                            await downloadCertificate(cert.certificate_id);
                          }}
                          className="hover:text-blue-800 cursor-pointer"
                        >
                          Baixar PDF
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          
          {/* Pagination */}
          {certificatesPagination && certificatesPagination.total_pages > 1 && (
            <div className="bg-white px-6 py-4 border-t border-gray-200 flex items-center justify-between">
              <div className="flex items-center">
                <p className="text-sm text-gray-700">
                  Mostrando {((certificatesPagination.current_page - 1) * certificatesPagination.per_page) + 1} a{" "}
                  {Math.min(certificatesPagination.current_page * certificatesPagination.per_page, certificatesPagination.total)} de{" "}
                  {certificatesPagination.total} resultados
                </p>
              </div>
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => onFetchCertificates(certificatesPagination.current_page - 1, certificateSearchTerm)}
                  disabled={!certificatesPagination.has_prev}
                  className="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Anterior
                </button>
                <span className="px-3 py-2 text-sm text-gray-700">
                  Página {certificatesPagination.current_page} de {certificatesPagination.total_pages}
                </span>
                <button
                  onClick={() => onFetchCertificates(certificatesPagination.current_page + 1, certificateSearchTerm)}
                  disabled={!certificatesPagination.has_next}
                  className="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Próxima
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CertificatesTab;
